import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 192 184"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#148EFF",
    d: "M151.133 62.644c-24.226-11.128-59.08-18.197-91.86-15.566C60.9 36.3 64.984 28.786 71.623 27.201c9.161-2.188 19.152 3.804 28.663 14.678 6.224.793 13.629 2.22 18.8 3.392C101.724 12.84 78.423-5.326 60.708 1.395 47.238 6.5 40.344 24.918 41.174 49.678 23.62 53.387 9.926 59.98 1.15 69.46c-.447.507-1.437 1.807-1.085 2.41.287.475 1.149-.064 1.564-.318 10.15-7.07 23.172-10.874 40.12-13.283 2.427 26.408 13.662 59.917 32.366 86.801-10.214 3.994-18.8 4.248-23.492-.698-6.48-6.784-6.256-18.387-1.532-32.019-2.426-5.77-4.883-12.84-6.416-17.848-19.661 31.163-23.874 60.297-9.16 72.186 11.203 9.035 30.705 5.77 51.867-7.323 12.002 13.251 24.609 21.716 37.249 24.505.67.127 2.298.349 2.649-.253.288-.476-.638-.983-1.053-1.173-11.235-5.199-21.066-14.488-31.631-27.867 21.832-15.28 45.42-41.72 59.496-71.235 8.586 6.817 13.086 14.045 11.139 20.575-2.681 8.972-12.895 14.583-27.162 17.31-3.831 4.977-8.746 10.62-12.353 14.456 36.962 1.268 64.475-9.669 67.476-28.247 2.298-14.139-10.342-29.293-32.334-40.96 5.554-16.96 6.639-32.018 2.745-44.287-.223-.634-.83-2.156-1.564-2.156-.542 0-.542 1.046-.51 1.49 1.149 12.237-2.011 25.362-8.395 41.118m-68.082 78.209c-15.64-24.918-24.64-54.274-24.609-83.947 29.557-.983 59.656 5.928 85.51 20.828-13.917 25.901-34.983 48.346-60.9 63.119"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h191.51v184H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }